<template>
    <div class="timeline">
        <template v-for="(item, index) in timeline">
            <Year :item="item" :key="index"/>
        </template>
    </div>
</template>
<script>
import Year from "./Year"
export default {
    name: "Timeline",
    props: {
        timeline: {
            type: Array,
            default: () => []
        }
    },
    components: {
        Year
    },
};
</script>
<style scoped>

.timeline {
    position: relative;
    margin: 0 auto;
    max-width: 1300px;
}
.timeline:before {
    content: none;
    position: absolute;
    height: 100%;
    border: var(--bd-sections);
    right: 40px;
    top: 0;
}
.timeline:after {
    content: "";
    display: table;
    clear: both;
}
@media screen and (min-width: 700px) {
    .timeline {
        padding: 2rem;
        padding: 1rem;
    }
    .timeline:before {
        left: calc(50% - 1px);
        right: auto;
        content: "";
    }
}
</style>
